import React from "react";
const RegNav = ({ setPageState, pageState, site, setSearch }) => {
  return (
    <div className="tabsWithSearch">
      <ul className="scroll_panel" id="tabs">
        <li onClick={() => setPageState("thumbs")}>
          <span
            className={
              pageState === "thumbs" ? "item_link active" : "item_link"
            }
          >
            Stories
          </span>
        </li>
        {site.customs === "y" && (
          <li onClick={() => setPageState("request")}>
            <span
              className={
                pageState === "request" ? "item_link active" : "item_link"
              }
            >
              Requests
            </span>
          </li>
        )}
        {site.live === "y" && (
          <li onClick={() => setPageState("live")}>
            <span
              className={
                pageState === "live" ? "item_link active" : "item_link"
              }
            >
              Live
            </span>
          </li>
        )}
      </ul>
      <div className="navSearch">
        <i className="icon-search" onClick={() => setSearch(true)} />
      </div>
    </div>
  );
};

export default RegNav;
